import React, { useState, useRef, useEffect } from 'react';
import { Stage, Layer, Image as KImage } from 'react-konva';

const STAGE_W = 1080;
const STAGE_H = 1080;

function useKonvaImage(url) {
  const [image, setImage] = useState(null);
  useEffect(() => {
    if (!url) { setImage(null); return; }
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => setImage(img);
    img.onerror = () => console.error('Bild konnte nicht geladen werden:', url?.substring(0, 80));
    img.src = url;
  }, [url]);
  return image;
}

export default function KonvaEditor({ template }) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(500);
  const bgImage = useKonvaImage(template?.url);

  // Responsive: Canvas skaliert auf Container-Breite
  useEffect(() => {
    const measure = () => {
      if (containerRef.current) {
        setContainerWidth(Math.min(containerRef.current.offsetWidth, 500));
      }
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  const scale = containerWidth / STAGE_W;

  return (
    <div ref={containerRef} style={{ maxWidth: '500px', margin: '0 auto' }}>
      <div style={{ borderRadius: '10px', overflow: 'hidden', border: '1px solid #e5e7eb', background: '#111' }}>
        <Stage
          width={STAGE_W}
          height={STAGE_H}
          scaleX={scale}
          scaleY={scale}
          style={{ width: containerWidth + 'px', height: containerWidth + 'px' }}
        >
          <Layer>
            {bgImage && (
              <KImage image={bgImage} width={STAGE_W} height={STAGE_H} listening={false} />
            )}
          </Layer>
        </Stage>
      </div>
      {!bgImage && (
        <div style={{ textAlign: 'center', padding: '12px', fontSize: '0.82rem', color: '#999' }}>
          Bild wird geladen...
        </div>
      )}
    </div>
  );
}
